import { render, staticRenderFns } from "./templates-dropdown.vue?vue&type=template&id=1abf934e"
import script from "./templates-dropdown.vue?vue&type=script&lang=js"
export * from "./templates-dropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports